//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { IAssetFeedSourceSettings } from '@streams/models/assetFeedsModalStateModel';

export enum ASSET_FEEDS_MODAL_ACTIONS {
  SET_ASSET_FEEDS_STREAM_SOURCE = 'ASSET_FEEDS_STREAM/SET_ASSET_FEEDS_STREAM_SOURCE',
  SET_ASSET_FEEDS_SOURCE_CONNECTION_STATE = 'ASSET_FEEDS_STREAM/SET_ASSET_FEEDS_SOURCE_CONNECTION_STATE',
  SET_CREATING_STREAM = 'ASSET_FEEDS_STREAM/SET_CREATING_STREAM',
  SET_UPDATING_SOURCES = 'ASSET_FEEDS_STREAM/SET_UPDATING_SOURCES',
  SET_UPDATING_FILTERS = 'ASSET_FEEDS_STREAM/SET_UPDATING_FILTERS',
  SET_INSTAGRAM_BUSINESS_USER_ID = 'ASSET_FEEDS_STREAM/SET_INSTAGRAM_BUSINESS_USER_ID',
  SET_EDITING_SOURCES = 'ASSET_FEEDS_STREAM/SET_EDITING_SOURCES',
  SET_CONFIRMATION_MODAL_OPEN = 'ASSET_FEEDS_STREAM/SET_CONFIRMATION_MODAL_OPEN',
}

export enum MEDIA_SOURCE {
  INSTAGRAM = 'instagram',
  UGC = 'ugc',
  UPLOADED = 'uploaded',
}

export const MEDIA_SOURCE_MAPPINGS = {
  [MEDIA_SOURCE.INSTAGRAM]: {
    title: 'Instagram',
    subtitle: 'Media posted to your Instagram account',
    icon: 'instagram',
    network: 'instagram',
  },
  [MEDIA_SOURCE.UGC]: {
    title: 'User-Generated Content',
    subtitle: 'Rights Approved Mentions & Tags, Tracked Users & Hashtags',
    icon: 'instagram',
    network: 'instagram',
  },
  [MEDIA_SOURCE.UPLOADED]: {
    title: 'Team Media',
    subtitle: 'Media added to Bazaarvoice by you and your team',
    icon: 'upload',
    network: 'uploaded',
  },
} as const;

export const DEFAULT_FILTERS = {
  spam: true,
  rights: { options: ['Owned'] },
  mediaTypes: { options: ['Image'] },
  height: {
    min: 600,
  },
  width: {
    min: 600,
  },
  aspectRatio: {
    min: 0.75,
    max: 1.333,
  },
};

export const generateDuplicateExclusionFilter = (
  sourceSettings: IAssetFeedSourceSettings,
) => {
  return {
    excludeMatchedMisItemForInstagramPost:
      sourceSettings.uploaded &&
      (sourceSettings.instagram ||
        sourceSettings.ugc ||
        sourceSettings.facebook),
    excludeOriginalRepostedInstagramItem: true,
    excludeMatchedInstagramItemForInstagramStory: true,
  };
};

export const UPLOADED_SOURCE = { allCuralateUsers: true };

export const UGC_SOURCE = { allInstagram: true };
